import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { addCandidate, addUser, getCandidateProfileById, view_resume } from "../../Api/apiService";
import { saveProfessionalSummary, saveCertificates, selectProfile } from "../../Redux/ResumeReducer/ResumeAction";

import LayoutHOC from "../../Components/Hoc/ResumeHoc";
import ContainerWrapper from "../../Components/ContainerWrapper/container-wrapper";
import { Col, Row, Tag } from "antd";
import ResumeSidebar from "../../Components/Sidebar/Resume-Sidebar";
import CreateResumeWrapper from "./components/Create-Resume-Wrapper";
import TextArea from "antd/es/input/TextArea";
import InputWrapper from "../../Components/Input/Input-Wrapper";
import CustomInput from "../../Components/Input/Custom-Input";
import CustomizeButton from "../../Components/Button/Customize-Button";

function ProfessionalSummary() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userData = useSelector((state) => state.resume);

  const selectedRole = useSelector((state) => state.auth);



  const user = JSON.parse(localStorage.getItem("auth")) || { name: "", email: "", userId: "" };
  const profileId = localStorage.getItem("profileId") || new URLSearchParams(window.location.search).get("profileId");
  const candidateUserId = new URLSearchParams(location.search).get("candidateProfileId");
  const employeeId = localStorage.getItem("selectedEmployeeId");
  const role = localStorage.getItem("selectedRole");
   const userDet = useSelector((state) => state.auth);
  const { userId } = userDet;
const profileData = useSelector((state) => state.resume.profileData || {});
  const certificatsfromStore = profileData.certificates || [];
  const professionalSummaryFromStore = profileData.professionalSummary || "";
  // Local state

  console.log("Certificates from Store:", certificatsfromStore);
  console.log("Professional Summary from Store:", professionalSummaryFromStore);

  const [certificationVal, setCertificationVal] = useState("");
  const [isSaved, setIsSaved] = useState(false);

  const selectedProfile = useSelector((state)=> state.resume.selectedProfile);
    const [resumeTitle, setResumeTitle] = useState("");
   const getInitialSummary = () => {
    return selectedProfile?.profileData?.professionalSummary || "";
  };


  const getInitialCertifications = () => {
    if (selectedProfile?.profileData?.certificates && selectedProfile.profileData.certificates.length > 0) {
      return selectedProfile.profileData.certificates.map((cert) => ({ 
        certification: cert, 
        collapsed: false 
      }));
    }
    return [{ certification: "", collapsed: false }];
  };
     const [summary, setSummary] = useState(getInitialSummary());
  const [certification, setCertification] = useState(getInitialCertifications());

 useEffect(() => {
  if (selectedProfile?.profileData) {
    setSummary(selectedProfile.profileData.professionalSummary || "");
    setCertification(
      selectedProfile.profileData.certificates?.length > 0
        ? selectedProfile.profileData.certificates.map((c) => ({ 
            certification: c, 
            collapsed: false 
          }))
        : [{ certification: "", collapsed: false }]
    );
  }
}, [selectedProfile]);
useEffect(() => {

  console.log("ProfileId:", profileId, "Role:", role, "CandidateUserId:", candidateUserId);

  if (role !== "candidate") {
    return;
  }
  const fetchProfile = async () => {
    try {
      let profile = {};

      if (role === "candidate" ) {
        const res = await getCandidateProfileById(profileId);
        if (res?.status === 200 || res?.status === 201) {
          profile = res.data.profileData || {};
          setResumeTitle(res.data.resumeTitle || ""); 
        }
      } 

      if (profile) {
      
        setSummary(profile.professionalSummary || "");
        setCertification(
          profile.certificates?.length > 0
            ? profile.certificates.map((c) => ({ certification: c, collapsed: false }))
            : [{ certification: "", collapsed: false }]
        );

        // Update redux store so other pages know about it
        dispatch({ type: "UPDATE_PROFILE_DATA", payload: profile });
      }
    } catch (err) {
      console.error("Error fetching professional summary:", err);
    }
  };

  fetchProfile();
}, [profileId, role, candidateUserId, employeeId, user.userId]);


useEffect(() => {
  dispatch(saveProfessionalSummary(summary));
  const filteredCerts = certification.map((c) => c.certification.trim()).filter((c) => c !== "");
  dispatch(saveCertificates(filteredCerts));
}, [summary, certification, dispatch]);


  // Handlers
  const handlePrevClick = () => {
    const formattedCertificates = certification
    .map((cert) => cert.certification?.trim())
    .filter((cert) => cert); 

  dispatch(saveProfessionalSummary(summary.trim()));
  dispatch(saveCertificates(formattedCertificates));


     if (selectedProfile) {
    dispatch(selectProfile({
      ...selectedProfile,
      profileData: {
        ...selectedProfile.profileData,
        professionalSummary: summary.trim(),
        certificates: formattedCertificates,
      },
    }));
  }
    dispatch({ 
      type: "UPDATE_PROFILE_DATA", 
      payload: {
        ...profileData,
        professionalSummary: summary.trim(),
        certificates: formattedCertificates,
      }
    });
    if (role === "employee") {
      navigate(profileId ? `/skills?profileId=${profileId}` : "/skills");
    } else if (role === "candidate") {
      navigate(candidateUserId ? `/skills?candidateProfileId=${candidateUserId}` : "/skills");
    } else {
      navigate(profileId ? `/skills?profileId=${profileId}` : "/skills");
    }
  };





  const handleDeleteClick = (index) => {
    const updatedFields = certification.filter((_, i) => i !== index);
    setCertification(updatedFields.length > 0 ? updatedFields : [{ certification: "", collapsed: false }]);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && certificationVal.trim() !== "") {
      setCertification([...certification, { certification: certificationVal, collapsed: false }]);
      setCertificationVal("");
    }
  };

  const handleSubmit = async () => {
    const updatedUserData = {
      ...userData,
      userId: userData.userId?.userId,
      profileId,
      profileName: user.name,
    };

    console.log(updatedUserData, "this is updated user data");

    try {
      const response = role === "candidate" ? await addCandidate(profileId, updatedUserData) : await addUser(profileId, userData);

      if (response.status === 200 || response.status === 201) {
        toast.success("Profile Created Successfully",{ autoClose: 2000 });
        setTimeout(() => {
          window.location.href = selectedRole.role === "ROLE_HR" ? "/dashboardHR" : "/dashboard";
        }, 3000);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong.", { autoClose: 2000 });
    }
  };
    const handleCancel = () => {
      navigate(user?.role === "ROLE_HR"  ? "/dashboardHr" : "/dashboard");
  }

  return (
    <>
      <ContainerWrapper breadcrumbItems={["Resume Builder", "Professional Summary"]}>
        <Row gutter={[20, 20]}>
          <Col span={6}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div>
                <ResumeSidebar title={resumeTitle || selectedProfile?.jobTitle ||"Resume Title"} />
              </div>
            </div>
          </Col>
          <Col span={18}>
            <CreateResumeWrapper title={"Professional Summary"}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  justifyContent: "space-between",
                }}
              >
                <Row
                  style={{
                    borderRadius: "10px",
                    padding: "16px",
                    border: "1px solid #E8E8E8",
                    marginBottom: "12px",
                  }}
                >
                  <InputWrapper className="bio-wrapper" label={"Summary"}>
                    <TextArea
                      value={summary}
                      onChange={(e) => setSummary(e.target.value)}
                      style={{
                        border: "1px solid #E8E8E8",
                        borderRadius: "10px",
                        width: "100%",
                        height: "20vh",
                        padding: "12px",
                        resize: "none",
                      }}
                      placeholder=""
                    />
                  </InputWrapper>

                  <InputWrapper
                    style={{
                      width: "100%",
                      marginTop: "20px",
                    }}
                    label={"Certificates"}
                  >
                    <div
                      style={{
                        display: "flex",
                        height: "64px",
                        borderRadius: "10px",
                        border: "1px solid #E8E8E8",
                        justifyContent: "center",
                        padding: "12px 16px",
                        alignItems: "center",
                        gap: "8px",
                        flexWrap: "wrap",
                      }}
                    >
                      {certification
                        .filter((c) => c.certification.trim() !== "")
                        .map((cert, index) => (
                          <Tag
                            key={index}
                            closable
                            onClose={(e) => {
                              e.preventDefault();
                              handleDeleteClick(index);
                            }}
                            style={{
                              padding: "8px 16px",
                              fontSize: "16px",
                              borderRadius: "10px",
                              background: "#FDEDEF",
                              border: "1px solid #910E11",
                              color: "#910E11",
                              height: "40px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {cert.certification}
                          </Tag>
                        ))}

                      {/* Input field to add new certificate */}
                      <CustomInput
                        style={{ height: "40px", border: "none", flex: 1 }}
                        value={certificationVal}
                        onChange={(e) => setCertificationVal(e.target.value)}
                        onKeyDown={handleKeyDown}
                      />
                    </div>
                  </InputWrapper>
                </Row>
                <Row
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                  }}
                >
                  <CustomizeButton onClick={handleSubmit} variant="primary" style={{ width: "14rem" }}>
                    {" "}
                    Submit{" "}
                  </CustomizeButton>
                  <CustomizeButton onClick={handlePrevClick} variant="outlined" style={{ width: "14rem" }}>
                    {" "}
                    Previous
                  </CustomizeButton>
                  <CustomizeButton variant="outlined" style={{ width: "14rem" }} onClick={handleCancel}>
                    {" "}
                    Cancel
                  </CustomizeButton>
                </Row>
              </div>
            </CreateResumeWrapper>
          </Col>
        </Row>
        <ToastContainer/>
      </ContainerWrapper>
    </>
  );
}

export default LayoutHOC(ProfessionalSummary, { withSidebar: true });
